module.exports = __webpack_public_path__ + "img/viber.07c0f475.png";